import React from "react";
import { Link } from "react-router-dom";

import { useLang } from "../utils/LangContext";
import localStorageHelper from "../utils/localStorageHelper";

function OngoingGameNotice({ className = "" }) {
  const { t } = useLang();
  const team = localStorageHelper.getItem("team");
  const game = localStorageHelper.getItem("game");

  if (!game?.hash || !team?.team_code) {
    return null;
  }

  return (
    <div
      className={`ongoing-game-notice alert alert-success d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2 text-center mb-0 ${className}`}
    >
      <span>
        {t("You already have ongoing game")}: {" "}
        <strong>{team.team_code}</strong>
      </span>
      <Link to="/mobile-requirements?redirect=/game&mode=continue" className="btn btn-secondary btn-sm">
        {t("Continue playing")}
      </Link>
    </div>
  );
}

export default OngoingGameNotice;
